import { subtract } from "lodash";
import FormulaLayoutUI from "./FormulaLayoutUI";

const PortNetWeight = ({ gross, tare, total_bag_weight, unit }) => {
  const finalVal = Number(subtract(subtract(Number(gross ?? 0), Number(tare ?? 0)), Number(total_bag_weight ?? 0))).toFixed(3)
  return (
    <FormulaLayoutUI>
      <strong>Port Net Weight Formula:</strong>
      <br />
      <br />
      = Gross Weight - Tare Weight - Total Bag Weights
      <br /> = {gross} - {tare} - {total_bag_weight} {unit}
      <br />
      <strong> </strong> = {finalVal} {unit}
    </FormulaLayoutUI>
  );
};

export default PortNetWeight;
